var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.23 30.15H20.4V27c0-1.99 1.84-3.6 3.83-3.6a3.37 3.37 0 1 1 0 6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 4a2 2 0 1 1 4 0v2h12V4a2 2 0 1 1 4 0v2h1a8 8 0 0 1 8 8v23a8 8 0 0 1-8 8H13a8 8 0 0 1-8-8V14a8 8 0 0 1 8-8h1V4Zm0 7V9.75h-2a3 3 0 0 0-3 3v3.75h30v-3.75a3 3 0 0 0-3-3h-2V11a2 2 0 1 1-4 0V9.75H18V11a2 2 0 1 1-4 0Zm10.23 9.6c-3.54 0-6.63 2.87-6.63 6.4v4.55c0 3.78 2.84 6.85 6.63 6.85h3.64a1.4 1.4 0 1 0 0-2.8h-3.64c-1.75 0-3.01-1.1-3.58-2.65h3.58a6.17 6.17 0 0 0 0-12.35Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.ce4af432e0fb9b05eb44ffdd6b89ba2e.svg";
export { ForwardRef as ReactComponent };